import { createContext, useContext, useState } from 'react';
import Data from '../data/Data';
import Cookies from 'js-cookie';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [isLoggedIn, setIsLoggedIn] = useState(Data.authCookieValue !== undefined);

  const login = () => {
    setIsLoggedIn(true);
  };

  const logout = () => {
    Cookies.remove('authCookie');
    window.location.href = '/';
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}